import React, { ReactNode } from "react";
import { Box, Grid } from "@mui/material";
import CircleIcon from "../../CircleIcon/CircleIcon";
import caseHistoryItemStyle from "./caseHistoryItemStyle";
import { GenericHistoryLog } from "../../../types/HistoryLog";
import dayjs from "dayjs";

interface GenericLogEntryProps {
  subject: string;
  Icon: any;
  iconType?: "muiIcon" | "iconFile";
  info?: ReactNode;
  historyItem: GenericHistoryLog;
  lineThrough?: boolean;
  userNameFallback?: string;
}

const GenericLogEntry = ({
  subject,
  Icon,
  iconType = "muiIcon",
  info = null,
  historyItem,
  lineThrough = false,
  userNameFallback = "System",
}: GenericLogEntryProps) => {
  return (
    <Grid container>
      <Grid size={1}>
        <CircleIcon icon={iconType === "muiIcon" ? <Icon /> : Icon} type={iconType} />
      </Grid>
      <Grid size={11}>
        <Box sx={lineThrough ? caseHistoryItemStyle.headlineLineThrough : caseHistoryItemStyle.headline}>{subject}</Box>
        <Box sx={caseHistoryItemStyle.info}>
          {info}
          {dayjs(historyItem.logDate).format("DD.MM.YYYY HH:mm")} Uhr |{" "}
          {historyItem?.backofficeUser?.person.fullname || userNameFallback}
        </Box>
      </Grid>
    </Grid>
  );
};

export default GenericLogEntry;
